import axios, {AxiosPromise} from "axios";
import {fetchDnhb} from '@dnhb/content-api-client';
import {Block} from "@dnhb/content-api-client/src/contract/notion";
import {Resource, SourceDef} from "../../contract/source";
import {RESOURCE} from "../../const";

type RequestBlockDef = (uuid: string) => AxiosPromise<Block[]>;

export const block: RequestEntryDef = (source = fetchDnhb, resource = RESOURCE.block) => {
  if (!source || !resource) return;
  const [method, dataFetchUrl] = resource;

  const fn: RequestBlockDef = (uuid) => {
    return source(`${dataFetchUrl}/${uuid}`, {
      client: axios.request,
      options: {
        method
      }
    });
  }

  return fn;
};

type RequestEntryDef = (source: SourceDef, resource?: Resource) => RequestBlockDef;

export const entry: RequestEntryDef = (source = fetchDnhb, resource = RESOURCE.article) => {
  if (!source || !resource) return;
  const [method, dataFetchUrl] = resource;

  const fn: RequestBlockDef = (uuid) => {

    return source(`${dataFetchUrl}/${uuid}`, {
      client: axios.request,
      options: {
        method
      }
    });
  }

  return fn;
};

type RequestEntriesDef = (source: SourceDef, resource?: Resource) => (options: {[key: string]: any}) => AxiosPromise<any>;

export const entries: RequestEntriesDef = (source = fetchDnhb, resource = RESOURCE.articles) => {
  if (!source || !resource) return;
  const [method, dataFetchUrl] = resource;

  const fn = (options: {[key: string]: any}) => {
    const {chunks, limit, page, ...query} = options;

    return source(dataFetchUrl, {
      client: axios.request,
      options: {
        method,
      },
      limit,
      page,
      chunks,
      query
    });
  }

  return fn;
};
